import {
  init_shadowMapFragment
} from "./chunk-JYG5YXGT.mjs";
import {
  init_packingFunctions
} from "./chunk-KUGAGCAX.mjs";
import {
  init_clipPlaneFragment
} from "./chunk-S7OWH5R2.mjs";
import {
  init_clipPlaneFragmentDeclaration
} from "./chunk-4NV4RXHT.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/bayerDitherFunctions.js
var name, shader;
var init_bayerDitherFunctions = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/bayerDitherFunctions.js"() {
    "use strict";
    init_shaderStore();
    name = "bayerDitherFunctions";
    shader = `fn bayerDither2(_P: vec2f)->f32 {return ((2.0*_P.y+_P.x+1.0)%(4.0));}
fn bayerDither4(_P: vec2f)->f32 {var P1: vec2f=((_P)%(2.0)); 
var P2: vec2f=floor(0.5*((_P)%(4.0))); 
return 4.0*bayerDither2(P1)+bayerDither2(P2);}
fn bayerDither8(_P: vec2f)->f32 {var P1: vec2f=((_P)%(2.0)); 
var P2: vec2f=floor(0.5 *((_P)%(4.0))); 
var P4: vec2f=floor(0.25*((_P)%(8.0))); 
return 4.0*(4.0*bayerDither2(P1)+bayerDither2(P2))+bayerDither2(P4);}
`;
    ShaderStore.IncludesShadersStoreWGSL[name] = shader;
  }
});

// node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/shadowMapFragmentExtraDeclaration.js
var name2, shader2;
var init_shadowMapFragmentExtraDeclaration = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/shadowMapFragmentExtraDeclaration.js"() {
    "use strict";
    init_shaderStore();
    init_packingFunctions();
    init_bayerDitherFunctions();
    name2 = "shadowMapFragmentExtraDeclaration";
    shader2 = `#if SM_FLOAT==0
#include<packingFunctions>
#endif
#if SM_SOFTTRANSPARENTSHADOW==1
#include<bayerDitherFunctions>
uniform softTransparentShadowSM: vec2f;
#endif
varying vDepthMetricSM: f32;
#if SM_USEDISTANCE==1
uniform lightDataSM: vec3f;varying vPositionWSM: vec3f;
#endif
uniform biasAndScaleSM: vec3f;uniform depthValuesSM: vec2f;
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
varying zSM: f32;
#endif
`;
    ShaderStore.IncludesShadersStoreWGSL[name2] = shader2;
  }
});

// node_modules/@babylonjs/core/ShadersWGSL/shadowMap.fragment.js
var name3, shader3, shadowMapPixelShaderWGSL;
var init_shadowMap_fragment = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/shadowMap.fragment.js"() {
    init_shaderStore();
    init_shadowMapFragmentExtraDeclaration();
    init_clipPlaneFragmentDeclaration();
    init_clipPlaneFragment();
    init_shadowMapFragment();
    name3 = "shadowMapPixelShader";
    shader3 = `#include<shadowMapFragmentExtraDeclaration>
#ifdef ALPHATEXTURE
varying vUV: vec2f;var diffuseSamplerSampler: sampler;var diffuseSampler: texture_2d<f32>;
#endif
#include<clipPlaneFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {
#include<clipPlaneFragment>
#ifdef ALPHATEXTURE
var opacityMap: vec4f=textureSample(diffuseSampler,diffuseSamplerSampler,fragmentInputs.vUV);var alphaFromAlphaTexture: f32=opacityMap.a;
#if SM_SOFTTRANSPARENTSHADOW==1
if (uniforms.softTransparentShadowSM.y==1.0) {opacityMap=vec4f(opacityMap.rgb* vec3f(0.3,0.59,0.11),opacityMap.a);alphaFromAlphaTexture=opacityMap.x+opacityMap.y+opacityMap.z;}
#endif
#ifdef ALPHATESTVALUE
if (alphaFromAlphaTexture<ALPHATESTVALUE) {discard;}
#endif
#endif
#if SM_SOFTTRANSPARENTSHADOW==1
#ifdef ALPHATEXTURE
if ((bayerDither8(floor(((fragmentInputs.position.xy)%(8.0)))))/64.0>=uniforms.softTransparentShadowSM.x*alphaFromAlphaTexture) {discard;}
#else
if ((bayerDither8(floor(((fragmentInputs.position.xy)%(8.0)))))/64.0>=uniforms.softTransparentShadowSM.x) {discard;} 
#endif
#endif
#include<shadowMapFragment>
}`;
    ShaderStore.ShadersStoreWGSL[name3] = shader3;
    shadowMapPixelShaderWGSL = { name: name3, shader: shader3 };
  }
});

export {
  shadowMapPixelShaderWGSL,
  init_shadowMap_fragment
};
